const QUESTION_BY_CHECK = {
  "Nombre del negocio": {
    question: "¿Cómo se llama tu negocio?",
    hint: "Este nombre aparece en la portada, el pie y los datos públicos.",
    action: { type: "section", section: "identity" },
  },
  "Descripción breve": {
    question: "¿Cómo explicarías tu negocio en una frase?",
    hint: "Pensá en alguien que entra por primera vez y todavía no sabe qué ofrecés.",
    action: { type: "section", section: "identity" },
  },
  "Logo principal": {
    question: "¿Querés agregar el logo de tu negocio?",
    hint: "Podés subirlo ahora o continuar y hacerlo más adelante.",
    action: { type: "section", section: "navbar", tool: "image" },
  },
  "Paleta definida": {
    question: "¿Qué colores representan mejor a tu negocio?",
    hint: "Los aplicaremos automáticamente en botones, títulos y fondos.",
    action: { type: "settings", tab: 0 },
  },
  "Título principal": {
    question: "¿Qué debería leer primero tu cliente?",
    hint: "Es el mensaje más importante de toda la página.",
    action: { type: "section", section: "hero" },
  },
  "Texto de apoyo": {
    question: "¿Qué ofrecés y por qué deberían elegirte?",
    hint: "Una explicación corta debajo del título alcanza.",
    action: { type: "section", section: "hero" },
  },
  "Imagen o slider": {
    question: "¿Te gustaría sumar una imagen de portada?",
    hint: "Puede ser una foto del negocio, un servicio o un producto principal.",
    action: { type: "section", section: "hero", tool: "image" },
  },
  "Botón principal": {
    question: "¿Qué acción querés que haga el visitante?",
    hint: "Por ejemplo: consultar, reservar, pedir presupuesto o ver servicios.",
    action: { type: "section", section: "hero" },
  },
  "Catálogo visible": {
    question: "¿Querés mostrar tus productos o servicios?",
    hint: "Activá el catálogo solamente cuando tenga sentido para este negocio.",
    action: { type: "section", section: "featured" },
  },
  "Mensaje principal del catálogo": {
    question: "¿Cómo presentarías lo que vendés u ofrecés?",
    hint: "Este texto acompaña los primeros productos o servicios destacados.",
    action: { type: "section", section: "featured" },
  },
  "Catálogo organizado": {
    question: "¿Cómo querés ordenar lo que ofrecés?",
    hint: "Podés usar categorías, marcas o un bloque destacado.",
    action: { type: "section", section: "categories" },
  },
  "Título institucional": {
    question: "¿Cómo presentarías la historia del negocio?",
    hint: "Esta sección ayuda a que el visitante sepa quién está detrás.",
    action: { type: "section", section: "about" },
  },
  "Historia o descripción": {
    question: "¿Qué historia querés contar sobre tu negocio?",
    hint: "No hace falta escribir mucho: experiencia, propósito y forma de trabajar.",
    action: { type: "section", section: "about" },
  },
  "Dos diferenciales claros": {
    question: "¿Por qué deberían elegirte a vos?",
    hint: "Agregá al menos dos ventajas concretas y fáciles de entender.",
    action: { type: "section", section: "highlights" },
  },
  "Canal de contacto": {
    question: "¿Cómo querés que te contacten?",
    hint: "Podés completar WhatsApp, teléfono o correo electrónico.",
    action: { type: "section", section: "contact", tool: "content" },
  },
  "Título de contacto": {
    question: "¿Cómo invitamos al visitante a contactarte?",
    hint: "Esta frase aparece antes de tus datos y botones de consulta.",
    action: { type: "section", section: "contact" },
  },
  "Mensaje de WhatsApp": {
    question: "¿Qué mensaje debería iniciar WhatsApp?",
    hint: "Dejalo preparado para que consultar sea más fácil.",
    action: { type: "section", section: "contact" },
  },
  "Título para Google": {
    question: "¿Cómo querés aparecer en Google?",
    hint: "Usá el nombre del negocio y su servicio principal.",
    action: { type: "settings", tab: 4 },
  },
  "Descripción para Google": {
    question: "¿Qué debería contar Google sobre tu negocio?",
    hint: "Una descripción breve mejora cómo se comparte y se encuentra la página.",
    action: { type: "settings", tab: 4 },
  },
  "Sitio publicado": {
    question: "¿La página ya está lista para publicarse?",
    hint: "Podés dejarla como borrador hasta terminar la revisión.",
    action: { type: "settings", tab: 4 },
  },
};

export function resolveNextStudioQuestion(progress) {
  const steps = Array.isArray(progress?.steps) ? progress.steps : [];

  for (const step of steps) {
    const missing = (step.checks || []).find(
      (check) => check.required !== false && !check.done
    );
    if (!missing) continue;

    const mapped = QUESTION_BY_CHECK[missing.label];
    return {
      stepId: step.id,
      stepLabel: step.shortLabel || step.label,
      checkLabel: missing.label,
      question: mapped?.question || `Completemos: ${missing.label}`,
      hint: mapped?.hint || step.description,
      action: mapped?.action || step.actions?.[0] || { type: "settings", tab: 0 },
    };
  }

  return {
    stepId: "publish",
    stepLabel: "Lista",
    checkLabel: "Web completa",
    question: "¿Querés revisar la página completa antes de salir?",
    hint: "Todo lo esencial está completo. Podés seguir ajustando cualquier sección tocándola.",
    action: { type: "settings", tab: 4 },
    complete: true,
  };
}
